/**
 * Unified event tracking — fans out to all web analytics services.
 *
 * Import `trackEvent` and `MixpanelEvents` from here instead of directly from
 * `./mixpanel` or `./events`.
 */

import { trackClarityEvent } from "./clarity";
import { MixpanelEvents } from "./events";
import {
  trackEvent as trackMixpanelEvent,
  trackPage as trackMixpanelPage,
} from "./mixpanel";
import type { T_AnalyticsProperties } from "./types";

export { MixpanelEvents };

/**
 * Track an event across all analytics services.
 *
 * Mixpanel receives the full event name + properties. Clarity receives the
 * event name only because its custom event API does not accept properties.
 */
export function trackEvent(
  name: string,
  properties?: T_AnalyticsProperties,
): boolean {
  const didTrackMixpanel = trackMixpanelEvent(name, properties);
  trackClarityEvent(name);
  return didTrackMixpanel;
}

export function trackPage(
  pageName: string,
  properties?: T_AnalyticsProperties,
): boolean {
  const didTrackMixpanel = trackMixpanelPage(pageName, properties);
  trackClarityEvent(MixpanelEvents.PAGE_VIEWED);
  return didTrackMixpanel;
}
